export default {"src":"/_next/static/media/Polygon.0a6f4002.svg","height":51,"width":80,"blurWidth":0,"blurHeight":0};